import { getData } from '@/utils/dataSync'

export async function getControlFileList() {
  let model = {
    key: 'controlFileList',
    dataType: 'server',
    requestParam: null,
    enableCache: true,
    method: 'get',
  }
  return getData(model)
}
